import React from 'react';
import Typography from 'new/elements/TypographySupport/TypographySupport';

import './ReusableTransformBannerActions.scss';

type Props = {
  openSupportModal(): void;
};

export function ReusableTransformDescription(props: Props) {
  const { openSupportModal, ...rest } = props;
  return (
    <Typography {...rest}>
      Easily manage custom code transformations for use with multiple Nexsets. Add
      <span role="button" className="description-link" onClick={openSupportModal}>
        {' '}
        Attribute Transforms{' '}
      </span>{' '}
      to define individual output attribute creation rules or{' '}
      <span role="button" className="description-link" onClick={openSupportModal}>
        {' '}
        Record Transforms{' '}
      </span>{' '}
      to define creation rules for the entire output Nexset record.
    </Typography>
  );
}
